import dayjs from "dayjs";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import imageCompression from "browser-image-compression";

export const getToken = () => {
  let token = "";
  var localData = JSON.parse(localStorage.getItem("recipe-user-data"));
  token = localData?.token;
  return token;
};

export const getStoreId = () => {
  const isStoreAdmin = window.location.pathname.includes("/store-admin");
  const localData = JSON.parse(localStorage.getItem("recipe-user-data"));
  return isStoreAdmin ? localData?.selectedStoreId : null;
};

export const successMessage = async (text) => {
  if (text === null || text === undefined || text === "")
    text = "Data saved successfully!";
  Toastify({
    text: text,
    duration: 3000,
    close: true,
    gravity: "top",
    position: "right",
    avatar: "/icons/success_toast.png",
    style: {
      background: "#388e3c",
    },
  }).showToast();
};
export const successRedMessage = async (text) => {
  if (text === null || text === undefined || text === "")
    text = "Data saved successfully!";
  Toastify({
    text: text,
    duration: 3000,
    close: true,
    gravity: "top",
    position: "right",
    avatar: "/icons/icon_not.svg",
    style: {
      background: "#FEB019",
    },
  }).showToast();
};
export const infoMessage = async (text) => {
  if (text === null || text === undefined || text === "") text = "Error";
  Toastify({
    text: text,
    duration: 3000,
    close: true,
    gravity: "top",
    position: "right",
    avatar: "/icons/error_toast.png",
    style: {
      background: "#FEB019",
    },
  }).showToast();
};

export const errorMessage = async (text) => {
  if (text?.errors || text?.error || text?.data) {
    // Extract error messages from the response object

    let errors = [];

    if (text?.errors && typeof text?.errors === "object") {
      errors = Object.values(text?.errors).flat();
    } else if (text?.error && typeof text?.error === "object") {
      errors = Object.values(text?.error).flat();
    } else if (text?.data && typeof text?.data === "object") {
      errors = Object.values(text?.data).flat();
    } else if (typeof text.error === "string") {
      errors = [text.error];
    } else if (typeof text.message === "string") {
      errors = [text.message];
    } else {
      errors = [JSON.stringify(text)];
    }

    const errorsString = errors.join(" ");

    Toastify({
      text: errorsString ?? "An error occurred",
      duration: 3000,
      close: true,
      gravity: "top",
      position: "right",
      avatar: "/icons/error_toast.png",
      style: {
        background: "#d32f2f",
      },
    }).showToast();
  } else if (text?.message) {
    Toastify({
      text: text.message,
      duration: 3000,
      close: true,
      gravity: "top",
      position: "right",
      avatar: "/icons/error_toast.png",
      style: {
        background: "#d32f2f",
      },
    }).showToast();
  } else {
    Toastify({
      text: text ?? "An error occurred",
      duration: 3000,
      close: true,
      gravity: "top",
      position: "right",
      avatar: "/icons/error_toast.png",
      style: {
        background: "#d32f2f",
      },
    }).showToast();
  }
};

export const arraySort = (data, key) => {
  return [...data].sort(function (a, b) {
    return a[key]?.toLowerCase()?.localeCompare(b[key]?.toLowerCase());
  });
};

export const navigateBasedOnUserType = (
  url = "",
  isStoreAdmin = false,
  navigate,
) => {
  return navigate(isStoreAdmin ? `/store-admin${url}` : url);
};

// Helper function to convert weight and unit
const convertWeightAndUnit = (weightInGrams, unitSymbol) => {
  if (weightInGrams >= 1000 && (unitSymbol === "gm" || unitSymbol === "ml")) {
    return {
      weight: weightInGrams / 1000,
      unit: unitSymbol === "gm" ? "kg" : "ltr",
    };
  } else if (
    weightInGrams < 1 &&
    (unitSymbol === "kg" || unitSymbol === "ltr")
  ) {
    return {
      weight: weightInGrams * 1000,
      unit: unitSymbol === "kg" ? "gm" : "ml",
    };
  } else {
    return { weight: weightInGrams, unit: unitSymbol };
  }
};

// Helper function to format the decimal part of the weight
const formatDecimalPart = (weight, unit, allUnits) => {
  const rounded =
    allUnits?.length &&
    allUnits?.find((u) => u?.label?.toLowerCase() === unit?.toLowerCase());
  const roundoffValue = rounded?.no_of_decimals;

  const [wholePart, decimalPart] = weight.toString().split(".");

  const formattedWeight =
    roundoffValue < 0 ? wholePart : Number(weight).toFixed(roundoffValue);

  return formattedWeight.toString();
};

// Helper function to trim trailing zeros in decimal part
const trimTrailingZeros = (formattedWeight) => {
  if (!formattedWeight?.includes(".")) return formattedWeight; // No decimal part

  const [wholePart, decimalPart] = formattedWeight.split(".");

  // Check if all decimal digits are zero
  if (/^0+$/.test(decimalPart)) {
    return wholePart;
  }

  return formattedWeight; // Return as is if any non-zero decimal digit exists
};

// Main function
export const formatWeightWithUnits = (weightInGram, unitSymbol, allUnits) => {
  const { weight, unit } = convertWeightAndUnit(
    Number(weightInGram),
    unitSymbol,
  );

  const formattedWeight = formatDecimalPart(weight, unit, allUnits);
  const finalWeight = trimTrailingZeros(formattedWeight);
  return `${finalWeight} ${unit}`;
};

export function convertStringToTime(input, type = null) {
  // Split input if it contains a colon (e.g., 3333:83)
  let [hoursPart, minutesPart] = String(input).split(":");

  //if input is empty , return 00:00
  if (!input) {
    return `00:00`;
  }

  // If minutesPart is undefined, treat the input as a pure number
  if (type === "minute") {
    // If no colon is present, treat input as a pure number in minutes
    const totalMinutes = parseInt(hoursPart, 10);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Format hours and minutes
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}`;
  }
  // If minutesPart is undefined, treat the input as a pure number
  if (!minutesPart) {
    const length = hoursPart.length;

    if (length === 1 || length === 2) {
      // For inputs with 1 or 2 digits, treat them as minutes
      minutesPart = hoursPart;
      hoursPart = "0";
    } else {
      // For inputs with 3 or more digits, split appropriately
      minutesPart = hoursPart.slice(-2); // Last two digits are minutes
      hoursPart = hoursPart.slice(0, -2) || "0"; // Remaining digits are hours
    }
  }

  // Convert to integers
  let hours = parseInt(hoursPart, 10);
  let minutes = parseInt(minutesPart, 10);

  // Handle minutes overflow
  if (minutes >= 60) {
    hours += Math.floor(minutes / 60);
    minutes %= 60;
  }

  // Format hours and minutes
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
}

export function convertTimeToMinute(time) {
  const [hours, minutes] = time.split(":").map(Number);
  const totalMinutes = hours * 60 + minutes;
  return totalMinutes;
}

export const parseFormattedWeight = (data) => {
  const value = data?.toString();

  const regex = /^([\d.]+)\s*(\w+)$/;
  const match = value?.match(regex);

  if (match) {
    const qtyString = match[1]; // Get the quantity part as a string
    const unit = match[2]; // Get the unit part

    // Preserve trailing zeros by keeping it as a string or formatting it
    const qty = qtyString; // Use the string directly to preserve trailing zeros

    return { qty, unit };
  }

  return { qty: null, unit: null };
};

export const downloadFile = ({
  response,
  fileName = "file",
  serverFileName = true,
}) => {
  const disposition = response.headers["content-disposition"];
  if (serverFileName)
    fileName =
      disposition?.split("filename=")[1]?.replace(/"/g, "") || fileName;

  const url = window.URL.createObjectURL(response.data);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;

  document.body.appendChild(a);
  a.click();

  a.remove();
  window.URL.revokeObjectURL(url);
};

export const printFile = (blob) => {
  let blobURL = URL.createObjectURL(blob);
  let iframe = document.createElement("iframe");
  document.body.appendChild(iframe);
  iframe.style.display = "none";
  iframe.src = blobURL;
  iframe.onload = function () {
    setTimeout(function () {
      iframe.focus();
      iframe.contentWindow.print();
    }, 1);
  };
};

// has uom unit conversion
export const UomConversion = (item) => {
  if (item?.use_uom && item.pivot.ignore === 0) {
    const formattedQty = item?.show_uom_unit_qty
      .map(({ qty, unit_name }) => `${qty} ${unit_name}`)
      .join(" + ");
    return `${formattedQty}`;
  } else {
    return `${item?.show_quantity}`;
  }
};

export const formatDate = (date, dateFormat = "YYYY-MM-DD") => {
  return dayjs(date).format(dateFormat);
};

export const formatFileSize = (bytes) => {
  if (!bytes || bytes <= 0) return "0 KB";

  const kb = bytes / 1024;
  if (kb < 1024) {
    return `${kb.toFixed(2)} KB`;
  }

  const mb = kb / 1024;
  return `${mb.toFixed(2)} MB`;
};

// cut in 3 decimal
export const formatCost = (cost) => {
  const value = Number(cost);

  if (value % 1 === 0) {
    return value.toString(); // Whole number, return as-is
  }

  const [intPart, decimalPart = ""] = value.toString().split(".");
  const truncatedDecimals = decimalPart.slice(0, 3).padEnd(3, "0");

  return `${intPart}.${truncatedDecimals}`;
};

export async function compressImage(imageFile, props = {}) {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1024,
    alwaysKeepResolution: true,
    useWebWorker: true,
    ...props,
  };

  try {
    const compressedFile = await imageCompression(imageFile, options);
    return compressedFile;
  } catch (error) {
    console.error(error);
    return imageFile; // fall back to original if compression fails
  }
}
